// @flow
import RichError from './RichError';

export default function trackError(message: string | Error) {
  let metadata = {};
  if (message instanceof RichError) {
    metadata = message.metadata;
  }
  if (window.trackJs && window.trackJs.track) {
    Object.keys(metadata).forEach(key => {
      window.trackJs.addMetadata(key, metadata[key]);
    });
    window.trackJs.track(message);
    Object.keys(metadata).forEach(key => {
      window.trackJs.removeMetadata(key);
    });
  }
}
